const handle = "johndoe"

const links = [
  {
    label: "Github",
    url: `https://github.com/julioprogrammer`,
  }
]

export default links
